import { BrButton, BrDateTimePicker, BrInput, Col, Row } from '@govbr-ds/react-components';
import { useContext, useState } from 'react';
import ComponentesBaseDeCalculoFormItemNCM from '../../../../../../components/baseDeCalculoFormItemNCM/baseDeCalculoFormItemNCM';
import { DiefCfemContext } from '../../../../../../contexts/DiefCfemContext';
import { useNotificacao } from '../../../../../../hooks/useNotificacao';
import {
  ICodigoNcm as ICodigoNcmBaseCalculo,
  IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao,
} from '../../../../../../interfaces/IBaseDeCalculo';
import { ICodigoNcm } from '../../../../../../interfaces/ICodigoNcm';
import { isFutureDate, isValidDate } from '../../../../../../utils/isDataValida';
import styles from './baseDeCalculoFormPorDoc.module.scss';

interface IPrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc {
  listaComponentesBaseCalculo: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[];
  setListaComponentesBaseCalculo: React.Dispatch<
    React.SetStateAction<IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[]>
  >;
  listaCodigosNCM: ICodigoNcmBaseCalculo[];
  setListaCodigosNCM: React.Dispatch<React.SetStateAction<ICodigoNcmBaseCalculo[]>>;
  codigosNCM: ICodigoNcm[];
  numeroProcesso: string;
}

function PrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc({
  listaComponentesBaseCalculo,
  setListaComponentesBaseCalculo,
  listaCodigosNCM,
  setListaCodigosNCM,
  codigosNCM,
  numeroProcesso,
}: IPrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc) {
  const [notaFiscal, setNotaFiscal] = useState('');
  const [dataEmissaoNF, setDataEmissaoNF] = useState('');

  const context = useContext(DiefCfemContext);
  const declaracaoPrimeiroAdquirente = context?.declaracaoPrimeiroAdquirente;

  const mostrarNotificacao = useNotificacao();

  const TAMANHO_MAXIMO_NFE = 44;

  const validarMesDiferente = function (emissao: string) {
    const mesDeclaracao = declaracaoPrimeiroAdquirente?.exercicioMes;
    const anoDeclaracao = declaracaoPrimeiroAdquirente?.exercicioAno;

    const dataSeparada = emissao.split('/');

    const mesEmissao = parseInt(dataSeparada[1]);
    const anoEmissao = parseInt(dataSeparada[2]);

    return mesDeclaracao !== mesEmissao || anoDeclaracao !== anoEmissao;
  };

  const onChangeDataNfe = (dataEmissaoNF: string) => {
    if (!dataEmissaoNF) {
      setDataEmissaoNF('');
    } else if (!isValidDate(dataEmissaoNF))
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'Data inválida. Por favor insira uma data válida.',
      });
    else if (validarMesDiferente(dataEmissaoNF)) {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'A data de emissão deve estar no mesmo mês da declaração',
      });
    } else if (isFutureDate(dataEmissaoNF)) {
      mostrarNotificacao({
        tipo: 'danger',
        conteudo:
          'A data de emissão que você digitou é uma data futura. Por favor insira uma data presente ou passada.',
      });
    } else {
      setDataEmissaoNF(dataEmissaoNF);
    }
  };

  const adicionarComponente = (e: React.FormEvent<HTMLFormElement>) => {
    // TODO - Validar se já não há aquisição para isso
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity()) {
      if (!dataEmissaoNF) {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Preencha a data de emissão da NF.',
        });
      } else if (listaCodigosNCM.length === 0)
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Preencha ao menos um item de NCM.',
        });
      else {
        form.reportValidity();
        const novaListaComponente = [...listaComponentesBaseCalculo];

        novaListaComponente.push({
          notaFiscal: notaFiscal.trim(),
          dataEmissaoNF,
          codigosNCM: listaCodigosNCM,
          quantidadeTotal: listaCodigosNCM.reduce((acc, item) => acc + parseFloat(item.quantidade), 0).toString(),
          valorTotal: listaCodigosNCM.reduce((acc, item) => acc + parseFloat(item.valor), 0).toString(),
        });
        setListaComponentesBaseCalculo(novaListaComponente);
        setListaCodigosNCM([]);
        setNotaFiscal('');
        setDataEmissaoNF('');
        const dataEmissaoNFElement = document.getElementById('dataEmissaoNF') as HTMLInputElement;
        if (dataEmissaoNFElement) {
          dataEmissaoNFElement.value = '';
        }
      }
    } else {
      form.reportValidity(); // Exibe as mensagens de erro padrão do navegador
    }
  };

  return (
    <form
      id='componenteFiscalForm'
      data-testid='componenteFiscalForm'
      className={styles.form}
      onSubmit={adicionarComponente}
    >
      <div className={styles.paddingContainer}>
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <span>Informe os dados da Nota Fiscal</span>
          </div>
          <Row className={styles.containerInterno}>
            <Col className={styles.adicaoComponenteFiscal}>
              <BrInput
                label='Nota Fiscal'
                autoComplete='off'
                value={notaFiscal}
                required
                numeric
                onChange={(e) => setNotaFiscal(e.target.value)}
                maxLength={TAMANHO_MAXIMO_NFE}
              />
            </Col>
            <Col className={styles.adicaoComponenteFiscal}>
              <BrDateTimePicker
                label='Data de Emissão da NF'
                id='dataEmissaoNF'
                dataMode='single'
                dataType='date'
                onChange={(e) => onChangeDataNfe(e)}
                minDate={
                  new Date(
                    declaracaoPrimeiroAdquirente?.exercicioAno ?? 0,
                    (declaracaoPrimeiroAdquirente?.exercicioMes ?? 0) - 1,
                    1
                  )
                }
                maxDate={
                  new Date(
                    declaracaoPrimeiroAdquirente?.exercicioAno ?? 0,
                    declaracaoPrimeiroAdquirente?.exercicioMes ?? 0,
                    0
                  )
                }
              />
            </Col>
            <Col></Col>
          </Row>
        </div>
        <div className={styles.container}>
          <ComponentesBaseDeCalculoFormItemNCM
            listaComponentesBaseCalculo={listaComponentesBaseCalculo}
            setListaComponentesBaseCalculo={setListaComponentesBaseCalculo}
            listaCodigosNCM={listaCodigosNCM}
            setListaCodigosNCM={setListaCodigosNCM}
            codigosNCM={codigosNCM}
            type='Aquisição'
            numeroProcesso={numeroProcesso}
          />
        </div>
      </div>
      <div className={styles.botao}>
        <BrButton type='submit' secondary>
          <i className={`fas fa-plus fa-md  ${styles.columnIcon}`} />
          <span>Adicionar Componente de Base de Cálculo</span>
        </BrButton>
      </div>
    </form>
  );
}

export default PrimeiroAdquirenteComponentesBaseDeCalculoFormPorDoc;
